import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Eemalda

  <span style="color:#85c1dc;">**FI:**</span>
  Poista

  <span style="color:#85c1dc;">**RU:**</span>
  Удалить
*/
/* @__NO_SIDE_EFFECTS__ */
const m1050 = msg(
  mf`Eemalda`,
  mf`Poista`,
  mf`Удалить`,
)

export { m1050 as 'w.basket.merge.button.remove' }